import * as t from 'io-ts';

import {makeEnumRuntimeType} from '../../../models/api/apiTypes';
import {CalendarWeekDaysEnum} from '../../../models/api/calendarCommonTypes';
import {RCalendarVersionIdRef} from '../../../models/api/calendarVersionModel';

/*
 * Runtime types.
 */

export enum CalendarsViewTypesEnum {
  DAY = 'DAY',
  WEEK = 'WEEK',
  MONTH = 'MONTH',
  PREVIEW = 'PREVIEW',
  SCHEDULING = 'SCHEDULING',
  REMINDERS = 'REMINDERS',
}

const RCalendarsParametersDirty = t.readonly(
  t.type({
    focusedDate: t.Integer,
    viewType: makeEnumRuntimeType(CalendarsViewTypesEnum),
    weekStartDay: makeEnumRuntimeType(CalendarWeekDaysEnum),
    selectedCalendarVersionIds: t.readonlyArray(RCalendarVersionIdRef),
    viewingNowCalendarVersionIds: t.readonlyArray(RCalendarVersionIdRef),
  }),
);

/*
 * Types.
 */

export interface CalendarsParameters extends Readonly<t.TypeOf<typeof RCalendarsParametersDirty>> {}
export const RCalendarsParameters = t.clean<CalendarsParameters>(RCalendarsParametersDirty as any);
